import { useQuery } from '@tanstack/react-query';
import { orgListKeys } from '@repo/query-keys/user';
import { axios } from '@repo/http';
import { get_organization_list_path } from 'ze-api-contract/user-v2/get-organization-list';
export const orgList = {
    organizationList: (userEmail)=>({
            queryKey: orgListKeys.organizationList(userEmail).queryKey,
            queryFn: async ()=>{
                if (!userEmail) {
                    return null;
                }
                return axios.get(get_organization_list_path({
                    userEmail
                })).then((res)=>res.data.entities);
            }
        })
};
export function useOrganizationList(userEmail) {
    const { data, error, isLoading } = useQuery(orgList.organizationList(userEmail));
    return {
        organizationList: data,
        isLoading,
        error
    };
}
